import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { login } from "../../redux/apiCalls"
import { changePrices } from "../../redux/environmentRedux"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
import Button from "../../components/Button/Button"
// Styles
import {
   Container,
   Wrapper,
   Form,
   Input,
   StyledLink,
   Title,
   Error,
} from "./Login.styles"

const Login = () => {
   const dispatch = useDispatch()
   const { isFetching, error } = useSelector((state) => state.user)
   const { t } = useTranslation()
   const [userName, setUserName] = useState("")
   const [password, setPassword] = useState("")

   const handleClick = (e) => {
      e.preventDefault()
      dispatch(changePrices(false))
      login({ userName, password }, dispatch)
   }

   return (
      <>
         <Helmet>
            <title>{t("loginPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar />
            <Wrapper>
               <Form>
                  <Title>{t("loginPage.title.t1")}</Title>
                  <Input
                     placeholder={t("loginPage.input.i1")}
                     onChange={(e) => setUserName(e.target.value)}
                  />
                  <Input
                     placeholder={t("loginPage.input.i2")}
                     type="password"
                     onChange={(e) => setPassword(e.target.value)}
                  />
                  {error && (
                     <Error>
                        {typeof error === "string"
                           ? error
                           : error.message || t("loginPage.error.generic")}
                     </Error>
                  )}
                  <Button
                     text={t("loginPage.button.b1")}
                     callback={(e) => handleClick(e)}
                     disabled={isFetching}
                     submit
                  />
                  <StyledLink to="/resetPassword/noUser/noEmail/noToken">
                     {t("loginPage.label.l1")}
                  </StyledLink>
                  <StyledLink to="/register">
                     {t("loginPage.label.l2")}
                  </StyledLink>
               </Form>
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default Login
